import { render, staticRenderFns } from "./tab-table-view.vue?vue&type=template&id=a74f14b2"
import script from "./tab-table-view.vue?vue&type=script&lang=js"
export * from "./tab-table-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports